<template>
  <a-drawer width="45%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="realName">
        <span slot="label">
          <a-tooltip>收货人<template slot="title">收货人</template></a-tooltip>
        </span>
        <a-input v-model="form.realName" :maxLength="32" :placeholder="$t('请输入')+'收货人'"/>
      </a-form-model-item>
      <a-form-model-item prop="sex">
        <span slot="label">
          <a-tooltip>性别<template slot="title">性别</template></a-tooltip>
        </span>
        <a-radio-group button-style="solid"  v-model="form.sex">
          <a-radio-button v-for="(item, index) in this.customDict.SexEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item prop="mobile">
        <span slot="label">
          <a-tooltip>手机号<template slot="title">手机号</template></a-tooltip>
        </span>
        <a-input v-model="form.mobile" :maxLength="32" :placeholder="$t('请输入')+'手机号'"/>
      </a-form-model-item>
      <a-form-model-item prop="isDefault">
        <span slot="label">
          <a-tooltip>是否默认<template slot="title">是否默认 1:是,0:否</template></a-tooltip>
        </span>
        <a-radio-group button-style="solid"  v-model="form.isDefault">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item prop="areaxId">
        <span slot="label">
          <a-tooltip>地区<template slot="title">地区</template></a-tooltip>
        </span>
        <a-cascader :options="areaList"
                    :field-names="{ label: 'areaName', value: 'areaId', children: 'children'}"
                    :placeholder="$t('请输入')+$t('商家.所在地')"
                    style="width: 100%" v-model="companyLocationSelected" allowClear @change="onCompanyLocationChange">
        </a-cascader>
      </a-form-model-item>
      <a-form-model-item prop="longitude">
        <span slot="label">
          <a-tooltip>经度<template slot="title">经度</template></a-tooltip>
        </span>
        <a-input v-model="form.longitude" :maxLength="32" />
      </a-form-model-item>
      <a-form-model-item prop="latitude">
        <span slot="label">
          <a-tooltip>纬度<template slot="title">纬度</template></a-tooltip>
        </span>
        <a-input v-model="form.latitude" :maxLength="32" />
      </a-form-model-item>
      <a-form-model-item prop="detailedAddress">
        <span slot="label">
          <a-tooltip>详细地址<template slot="title">详细地址</template></a-tooltip>
        </span>
        <div id="amap" style="height: 450px;">
          <merchant-map ref="merchantMap" @updateLocationMap="updateLocationMap"   style="height: 100%;" />
        </div>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getMerchantAddress, addMerchantAddress, updateMerchantAddress} from '@/api/merchant/merchantAddress'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import MerchantMap from '@/views/common/map.vue'


export default {
  name: 'CreateForm',
  props: {
    areaList:{
      type: Array,
      required: true
    }
  },
  components: {
    CustomDictTag,
    MerchantMap
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        sex:1,
        realName: null,
        mobile: null,
        longitude: null,
        latitude: null,
        areapId: null,
        areap: null,
        areacId: null,
        areac: null,
        areaxId: null,
        areax: null,
        detailedAddress: null,
        merchantId: null,
        isDefault: null,
        deptId: null,
        createTime: null,
      },
      companyLocationSelected: [],
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        realName: [{required: true, message: '收货人' + this.$t('不能为空'), trigger: 'blur'}],
        mobile: [{required: true, message: '手机号' + this.$t('不能为空'), trigger: 'blur'}],
        areaxId: [{required: true, message: '地区' + this.$t('不能为空'), trigger: 'blur'}],
        detailedAddress: [{required: true, message: '详情地址' + this.$t('不能为空'), trigger: 'blur'}],
        merchantId: [{required: true, message: '商家id' + this.$t('不能为空'), trigger: 'blur'}],
        isDefault: [{required: true, message: '是否默认 1:是,0:否' + this.$t('不能为空'), trigger: 'blur'}],
        deptId: [{required: true, message: '所属部门' + this.$t('不能为空'), trigger: 'blur'}]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
      this.$refs.merchantMap.initMarker(null, null, null, null);
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        sex:1,
        realName: null,
        mobile: null,
        longitude: null,
        latitude: null,
        areapId: null,
        areap: null,
        areacId: null,
        areac: null,
        areaxId: null,
        areax: null,
        detailedAddress: null,
        merchantId: null,
        isDefault: null,
        deptId: null,
        createTime: null,
      }
      this.companyLocationSelected = []
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getMerchantAddress({"id": id}).then(response => {
        this.form = response.data
        this.companyLocationSelected.push(this.form.areaxId.substring(0, 2) + '0000');
        this.companyLocationSelected.push(this.form.areaxId.substring(0, 4) + '00');
        this.companyLocationSelected.push(this.form.areaxId);
        this.open = true
        this.formTitle = this.$t('修改')
        this.$nextTick(()=>{
          this.initMap()
        })
      })
    },
    initMap(){
      let longitude = this.form.longitude
      let latitude = this.form.latitude
      let areac = this.form.areac
      let detailedAddress = this.form.detailedAddress
      this.$refs.merchantMap.initMarker(longitude, latitude, areac, detailedAddress);
    },

    /*省市区的选择, onchange方法*/
    onCompanyLocationChange(value, selectedOptions) {
      console.log(selectedOptions,'省区')
      this.form.areaxId = value[2]
      //初始化地图
      this.$refs.merchantMap.initMarker(selectedOptions[2].longitude, selectedOptions[2].latitude, value[1], '');
    },
    updateLocationMap(data) {
      console.log('地图选点',data)
      this.form.latitude = data.lat
      this.form.longitude = data.lon
      this.form.detailedAddress=data.orgAddr
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateMerchantAddress(this.form).then(response => {
              this.$message.success(message, 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addMerchantAddress(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
